module.exports = __webpack_public_path__ + "static/black-dragon-variant-mtg_afr-72f592d923c80471e453db767bb6a2aa.jpg";